module.exports = __webpack_public_path__ + "static/media/enterpreneur-cropped.d60453b4.jpg";